import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { freshcue } from 'src/backend';

export const FRESHCUE_ORGANIZATIONS_QUERY_KEY = [
  'freshcue',
  'available-organizations',
];

export function useFreshcueOrganizations({
  search,
  limit,
  offset,
  enabled = true,
} = {}) {
  return useQuery({
    queryKey: [
      ...FRESHCUE_ORGANIZATIONS_QUERY_KEY,
      search || '',
      limit ?? '',
      offset ?? '',
    ],
    refetchOnWindowFocus: false,
    queryFn: () =>
      freshcue.getAvailableBusinessOrganizations({ search, limit, offset }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
